import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Select, { components } from "react-select";
import { Button, Card, CardBody, Col, Container, FormGroup, Input, Row, Label } from "reactstrap";
import withReducer from "../../../store/withReducer";
import partnerPromotionReducer from "../store";
import Breadcrumbs from "../../../layout/breadcrumb";
import DateRangePickerDefault from "../../../share-components/ui/DateRangePickerDefault";
import ButtonLoader from "../../../share-components/ui/buttonLoader";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import ApprovalModal from "../../manage-product/partner-promotion/content/approvalModal";
import DeclineModal from "../../manage-product/partner-promotion/content/declineModal";
import {
  approveDiffDiscount,
  declineDiffDiscount,
  exportPriceMismatcReport,
  getDifferenceDiscount,
  getPartnerPromotionSettings,
  getPriceMismatch,
  setPartnerPromotionSettings,
} from "../../manage-product/store/partnerPromotionSlice";

function PriceMismatch() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [timer, setTimer] = useState(null);
  const [isDownloadReport, isSetDownloadReport] = useState(false);
  const partnerPromotionState = useSelector(({ partnerPromotion }) => partnerPromotion.partnerPromotion);
  const allSettings = useSelector(({ partnerPromotion }) => partnerPromotion.partnerPromotion?.settings);
  const [selectedRows, setSelectedRows] = useState([]);
  const [tableItems, setTableItems] = useState([]);
  const TodayDate = new Date();
  const sevenDays = new Date().setDate(TodayDate.getDate() - 90);
  const [promotionDateRange, setPromotionDateRange] = useState([null, null]);
  const [promotionStartDate, promotionEndDate] = promotionDateRange;
  const [orderDateRange, setOrderDateRange] = useState([sevenDays, TodayDate]);
  const [orderStartDate, orderEndDate] = orderDateRange;
  const [tableLoading, setTableLoading] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [approveBtnLoading, setApproveBtnLoading] = useState(false);
  const [declineBtnLoading, setDeclineBtnLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenDecline, setIsOpenDecline] = useState(false);
  const [selectedReason, setSelectedReason] = useState(null);
  const [filterPartner, setFilterPartner] = useState(null);
  const [filterStatus, setFilterStatus] = useState({ id: 0, name: "Pending" });
  const [filterSKU, setFilterSKU] = useState("");
  const [filterOrderNo, setFilterOrderNo] = useState("");
  const [lastFillters, setLastFillters] = useState(null);
  const isValidDate = (d) => d !== null && d !== undefined && moment(d).isValid();
  const [filters, setFilters] = useState({
    page: 1,
    pageSize: 10,
    // set initial dates to null if not provided
    start_date: isValidDate(promotionStartDate) ? moment(promotionStartDate).format("YYYY-MM-DD") : null,
    end_date: isValidDate(promotionEndDate) ? moment(promotionEndDate).format("YYYY-MM-DD") : null,
    order_startdate: isValidDate(orderStartDate) ? moment(orderStartDate).format("YYYY-MM-DD") : null,
    order_enddate: isValidDate(orderEndDate) ? moment(orderEndDate).format("YYYY-MM-DD") : null,
    // Add new filter properties
    partner: filterPartner ? filterStatus.id : null,
    sku: filterSKU ?? null,
    order_no: filterOrderNo ?? null,
    status: filterStatus ? filterStatus.id : null,
    draw: 1,
  });

  const statusItems = [
    { id: 0, name: "Pending" },
    { id: 1, name: "Approved" },
    { id: 2, name: "Declined" },
  ];

  const dataMenu = [
    {
      type: 1,
      text: "Orders",
      link: "/orders",
    },
    {
      type: 0,
      text: "Price Mismatch",
    },
  ];

  useEffect(() => {
    dispatch(getPartnerPromotionSettings()).then((res) => {
      dispatch(setPartnerPromotionSettings(res.payload));
    });
  }, [dispatch]);

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      order_startdate: isValidDate(orderStartDate) ? moment(orderStartDate).format("YYYY-MM-DD") : null,
      order_enddate: isValidDate(orderEndDate) ? moment(orderEndDate).format("YYYY-MM-DD") : null,
      page: 1, 
    }));
  }, [orderStartDate, orderEndDate]);

  useEffect(() => {
    getData();
  }, [dispatch, filters]);

  const mapResponseToTable = (response) => {
    return response.map((res, index) => {
      let result = {
        ...res,
        isChecked: false,
      };
      return result;
    });
  };

  const getData = () => {
    if (JSON.stringify(filters) == JSON.stringify(lastFillters)) return;

    setLastFillters(filters);
    setTableLoading(true);

    dispatch(getPriceMismatch(filters)).then((res) => {
      let items = [...mapResponseToTable(res.payload)];
      setSelectedRows([]);
      setTableItems(items);
      setTableLoading(false);
      setButtonDisabled(false);
      setApproveBtnLoading(false);
      setDeclineBtnLoading(false);
      setIsOpen(false);
    });
  };

  const eventExport = () => {
    if (isDownloadReport) {
      return;
    }
    isSetDownloadReport(true);
    dispatch(exportPriceMismatcReport(filters)).then((res) => {
      const link = document.createElement("a");
      link.href = res.payload;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      link.remove();
      isSetDownloadReport(false);
    });
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
      page: 1, // Reset to first page when filters change
    }));
  };

  const handleTextInputChange = (key, value) => {
    clearTimeout(timer);
    const newTimer = setTimeout(() => {
      setFilters((prev) => ({
        ...prev,
        [key]: value ?? null,
        page: 1, // Reset to first page when filters change
      }));
    }, 500);
    setTimer(newTimer);
  };

  // Clear all filters
  const clearFilters = () => {
    setFilterPartner(null);
    setFilterStatus(null);
    setFilterSKU("");
    setFilterOrderNo("");
  };

  const tableColumns = [
    {
      name: (
        <input
          onChange={(e) => {
            allCheckBoxChange(e.target.checked);
          }}
          type={"checkbox"}
        />
      ),
      cell: (row) => {
        return (
          <input
            onChange={(e) => {
              row.isChecked = e.target.checked;
              updateRowData(row.id, row);
            }}
            checked={row.isChecked}
            type={"checkbox"}
          />
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      sortable: false,
      center: true,
      width: "80px",
    },
    {
      name: "Order Name",
      selector: (row) => row.order_name,
      sortable: true,
      center: false,
    },
    {
      name: "SKU",
      sortable: true,
      center: false,
      selector: (row) => row.product_sku,
    },
    {
      name: "Partner Name",
      selector: (row) => row.partner_name,
      sortable: true,
      center: false,
    },
    {
      name: "Product Name",
      sortable: true,
      center: false,
      selector: (row) => row.product_name,
    },
    {
      name: "Quantity",
      selector: (row) => row.quantity,
      sortable: true,
      center: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      center: true,
    },
    {
      name: "Actual Price",
      selector: (row) => row.actual_price,
      sortable: true,
      right: true,
    },
    {
      name: "Actual Sale Price",
      selector: (row) => row.actual_sale_price,
      sortable: true,
      right: true,
    },
    {
      name: "Sale Price",
      selector: (row) => row.sale_price,
      sortable: true,
      right: true,
    },
    {
      name: "Total Order Amount",
      selector: (row) => row.total_order_amount,
      sortable: true,
      right: true,
    },
  ];

  const updateRowData = (id, newData) => {
    const updatedData = tableItems.map((row) => {
      return row.id === id ? { ...row, ...newData } : { ...row };
    });
    setTableItems(updatedData);

    // Update for seleted data
    const updatedSeletedData = updatedData.filter((row) => {
      return row.isChecked == true;
    });
    setSelectedRows(updatedSeletedData);
  };

  const allCheckBoxChange = (isChecked) => {
    tableItems.forEach(function (item) {
      item.isChecked = isChecked;

      updateRowData(item.id, item);
    });
  };

  const onClickApprove = () => {
    setButtonDisabled(true);
    setApproveBtnLoading(true);
    const orderItemIds = selectedRows.map(function (item) {
      return item.id;
    });
    dispatch(approveDiffDiscount({ ids: orderItemIds, reason_id: selectedReason })).then((response) => {
      setFilters({ ...filters, draw: filters.draw + 1 });
      setIsOpen(false)
      clearFilters();
    });
  };

  const onClickDecline = () => {
    setButtonDisabled(true);
    setDeclineBtnLoading(true);
    const orderItemIds = selectedRows.map(function (item) {
      return item.id;
    });

    dispatch(declineDiffDiscount({ ids: orderItemIds, reason_id: selectedReason })).then((response) => {
      setFilters({ ...filters, draw: filters.draw + 1 });
      setIsOpenDecline(false)
      clearFilters();
    });
  };

  const onPageSizeChange = (newPageSize) => {
    setFilters((prev) => ({
      ...prev,
      page: 1,
      pageSize: newPageSize === "All" ? partnerPromotionState.priceMismatchData.totalRow : newPageSize,
    }));
  };

  const onPageChange = (e) => {
    setFilters({ ...filters, page: e });
  };

  return (
    <Fragment>
      <Breadcrumbs title="Price Mismatch" data={dataMenu} />
      <Container fluid={true}>
        {/* New Filters Card */}
        <Card>
          <CardBody className="p-3">
            <Row>
              <Col sm={2}>
                <FormGroup>
                  <DateRangePickerDefault
                    placeholder="Search order date"
                    defaultValue={orderDateRange}
                    dateRange={orderDateRange}
                    dateRangeChange={(date) => {
                      setOrderDateRange(date);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col sm={2}>
                <FormGroup>
                  <Select
                    className="select2-filter"
                    placeholder="Partner"
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    value={filterPartner}
                    onChange={(e) => {
                      handleFilterChange("partner", e ? e.id : null);
                      setFilterPartner(e);
                    }}
                    components={{
                      IndicatorSeparator: () => null,
                      DropdownIndicator: (props) => {
                        return filterPartner ? null : <components.DropdownIndicator {...props} />;
                      },
                    }}
                    isClearable={true}
                    options={allSettings?.partners || []}
                  />
                </FormGroup>
              </Col>
              <Col sm={2}>
                <FormGroup>
                  <Input
                    type="text"
                    id="filterSKU"
                    placeholder="SKU"
                    value={filterSKU}
                    onChange={(e) => {
                      handleTextInputChange("sku", e.target.value);
                      setFilterSKU(e.target.value);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col sm={2}>
                <FormGroup>
                  <Input
                    type="text"
                    id="filterOrderNo"
                    placeholder="Order name"
                    value={filterOrderNo}
                    onChange={(e) => {
                      handleTextInputChange("order_no", e.target.value);
                      setFilterOrderNo(e.target.value);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col sm={2}>
                <FormGroup>
                  <Select
                    className="select2-filter"
                    placeholder="Status"
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    value={filterStatus}
                    onChange={(e) => {
                      handleFilterChange("status", e ? e.id : null);
                      setFilterStatus(e);
                    }}
                    components={{
                      IndicatorSeparator: () => null,
                      DropdownIndicator: (props) => {
                        return filterStatus ? null : <components.DropdownIndicator {...props} />;
                      },
                    }}
                    isClearable={true}
                    options={statusItems}
                  />
                </FormGroup>
              </Col>
              <Col>
                <div className="d-flex justify-content-end align-items-center mb-3">
                  <div>
                    <button type="button" onClick={eventExport} className="btn btn-sm btn-dark mr-2" disabled={isDownloadReport}>
                      <i className={isDownloadReport ? "fa fa-spinner fa-spin mr-1" : "fa fa-download mr-1"}></i> Export
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Card>
          <CardBody className="p-3">
            <ButtonLoader
              color="success"
              size="sm"
              className="mr-2 mb-2"
              btntext="Approve"
              onClick={() => {
                setIsOpen(true);
              }}
              disabled={buttonDisabled || !selectedRows.length}
              loading={approveBtnLoading}
            />

            <ButtonLoader
              color="danger"
              size="sm"
              className="mr-2 mb-2"
              btntext="Decline"
              onClick={() => {
                setIsOpenDecline(true);
              }}
              disabled={buttonDisabled || !selectedRows.length}
              loading={declineBtnLoading}
            />

            <div className="table-responsive product-table">
              <CommonDataTable
                headerColumns={tableColumns}
                gridData={tableItems}
                progressPending={tableLoading}
                noAction
                paginationServer
                paginationTotalRows={partnerPromotionState.priceMismatchData.totalRow}
                currentPage={filters.page}
                perPage={filters.pageSize}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                onChangeRowsPerPage={onPageSizeChange}
                onChangePage={onPageChange}
              />
            </div>
          </CardBody>
        </Card>
      </Container>

      {/* Approve Modal */}
      <ApprovalModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        reasonItems={allSettings.discountApprovalReasons}
        onClickApprove={onClickApprove}
        selectedReason={selectedReason}
        setSelectedReason={setSelectedReason}
        disabled={buttonDisabled}
        loading={approveBtnLoading}
      />

      {/* Decline Modal */}
      <DeclineModal
        isOpen={isOpenDecline}
        setIsOpen={setIsOpenDecline}
        reasonItems={allSettings.discountDeclineReasons}
        onClickDecline={onClickDecline}
        selectedReason={selectedReason}
        setSelectedReason={setSelectedReason}
        disabled={buttonDisabled}
        loading={declineBtnLoading}
      />
    </Fragment>
  );
}

export default withReducer([{ partnerPromotion: partnerPromotionReducer }])(PriceMismatch);
